import { createI18n } from 'vue-i18n'

const i18n = createI18n({
    locale: "fr",
    fallbackLocale: "fr",
    messages: {
        fr: {
            slogan:'Ton <objet> a plus de valeur que ton <ex> ? Vends-le !',
            entrerlaraisondelannulationenfrancais:'Entrez la raison de l\'annulation en français',
            entrerlaraisondelannulationenanglais:'Entrez la raison de l\'annulation en anglais',
            vousetessurlepointdannulerlacommande: 'Vous êtes sur le point d\'annuler la commande',
            erreurlorsduprocessusdevalidationdelacommande: 'Erreur lors du processus de validation de la commande',
            relainotfound:'Ce compte n\'est pas lié à un point de relai', 
            accessinterdit:'accès interdit',
            total:"Total",
            messagecordiale:"ce reçu ne confirme pas la légalité du produit, mais simplement la confirmation de la transaction sur la plateforme.",
            numero:"Numéro",
            facture:'facture',
            messageerrorrectoverso:"les photos recto/verso de la cni sont necessaires",
            messageerrorrectoversoacheteur:"Ajoutez le recto et le verso de la CNI de l'acheteur",
            messageerrorrectoversovendeur:"Ajoutez le recto et le verso de la CNI du vendeur",
            taillecni:"Image JPG, PNG, GIF ou WEBP, 5 Mo max",
            remplacerimage:"Remplacer",
            recuperationvalidee:"Recuperation validee",
            Avezvousrecularticledelacommande:"Avez-vous reçu l'article de la commande",
            validez:"Validez",
            rectodelacniduvendeur:"recto de la cni du vendeur",
            versodelacniduvendeur:"verso de la cni du vendeur",
            rectodelacnidelacheteur:"recto de la cni de l'acheteur",
            versodelacnidelacheteur:"verso de la cni de l'acheteur",
            voulezvousvalisezcommande:"Voulez-vous validez la commande",
            pointderelais:"Point de relai No",
            connecter: 'Connectez-vous',
            messagelogin:'Entrez votre e-mail et votre mot de passe.',
            nomutilisateur:'Nom d\'utilisateur',
            motdepasse:'Mot de passe',
            motdepasseoublie:'Mot de passe oublié ?',
            btnconnecter: 'Se connecter',
            pasencoreconnecte: 'Pas encore de compte ?',
            creeruncompte:'Créez-en un ici.',
            partagerseque:'Partagez ce que',
            vousnutilisezplus:'vous n\'utilisez plus',
            nousle :'nous le ',
            revendons:'revendons',
            pourvous:'pour vous.',
            inscription:'Inscrivez-vous',
            messageinscription:'Entrez vos informations pour valider l\'inscription.',
            vousavezdejauncompte: 'Vous avez déjà un compte ?',
            connectervousici:'Connectez-vous ici.',
            btninscription: 'S\'inscrire maintenant',
            confirmemotdepasse:'Confirmez le mot de passe',
            nouveaumotdepasse:'Nouveau mot de passe',
            email:'Email',
            langue:'Langue',
            ventesflash:'Ventes flash',
            lesventesseterminentdans:'Les ventes se terminent dans',
            lesventesrecommenceronta:'Les ventes recommenceront à',
            affichertouslesarticles:'Afficher tous les articles',
            debuterunevente:'Débuter une vente',
            bannierepublicitaire:'Bannière publicitaire',
            prix:'Prix',
            delailivraison:'Délai de livraison',
            delairecuperation:'Délai de récupération',
            validele:'Validée le',
            annulele:'Annulée le',
            categories:'Catégories',
            avismoyen:'Avis moyen',
            accueil:'Accueil',
            boutiques:'Boutiques',
            consulter:'Consulter',
            encheres:'Enchères',
            monprofil:'Mon profil',
            recherchez:'Recherchez...',
            abonnes:'abonnés',
            entrepreneuse:'Entrepreneuse',
            entrepreneur:'Entrepreneur',
            niveau:'Niveau',
            alert:'Il est important de mettre régulièrement vos informations à jour.',
            moncompte:'Mon compte',
            compte:'Compte',
            mesabonnees:'Mes abonnées',
            mescommandes:'Commandes',
            portefeuille:'Mon portefeuille',
            debit:'Débits',
            credit:'Crédits',
            mesarticles:'Mes articles',
            messtatistiques:'Mes statistiques',
            description:'Description',
            membredepuis:'Membre depuis',
            produit:'Produit',
            ajoutdunnouveauproduit:'Ajout d\'un nouveau produit',
            cliquezouglissezpourajouterdesimages:'Cliquez ou Glissez pour ajouter des images.',
            pourrecevoirlespropositionsdeprixactiverlesencheres:'pour recevoir les propositions de prix activer les enchères',
            publiercetarticle:'Publier cet article',
            marque:'Marque',
            nom:'Nom',
            couleur:'Couleur',
            taille:'Taille',
            ville:'Ville',
            stockage:'Stockage',
            pixelcameraavant:'Pixel Camera avant',
            pixelcameraarriere:'Pixel Camera arrière',
            ram:'Ram',
            Empreinte:'Empreinte',
            non:'Non',
            oui:'Oui',
            cpu:'Cpu(processeur)',
            systemedexploitation:'Système d’exploitation',
            cartegraphiquededie:'Carte graphique dédié',
            etatsur10:'Etat sur 10',
            tailleenpouce:'Taille en pouce',
            quantiteenlitre:'Quantité en litre',
            quartier:'Quartier',
            superficie:'Superficie',
            nombredepiece:'Nombre de pièce',
            nombredechambre:'Nombre de chambre',
            nombredesalon:'Nombre de salon',
            nombrededouche:'Nombre de douche',
            nombredecuisine:'Nombre de cuisine',
            prixminimaldelenchere:'Prix minimal de l\'enchère',
            numerodirect:'Numéro direct',
            numerowhatsapp:'Numéro whatsapp',
            quantitedisponible:'Quantité disponible',
            exemplenike:'Exemple: Nike',
            exempleairmax:'Exemple: Air MAX',
            rouge:'Rouge',
            exemplexlou42:'Exemple: XL ou 42',
            exempledouala:'Exemple: Douala',
            descriptionaddproduct:'Faite une description du produit en y ajoutant autant de détail que possible',
            exemple500go:'Entrez la valeur en Gigaoctet',
            exemple8megapixel:'Entrez la valeur en Mégapixel',
            exemple16go:'Entrez la valeur en Gigaoctet',
            exemple2ghz:'Entrez la valeur en Gigahertz',
            exemplewindows10ouandroid:'Exemple: windows 10 ou Android',
            exemple2go:'Entrez la valeur en Mégaoctet',
            exmepleetat:'Entrez la valeur sur 10',
            exemplepouces:'Entrez la valeur en pouces',
            exemple1litre:'Entrez la valeur en litre',
            exemplevillageentreebille:'Exemple: Village entrée bille',
            exemple250metrecarre:'Entrez la valeur en mètre carré',
            exemple6:'Exemple: 6',
            exemple2:'Exemple: 2',
            exemple1:'Exemple: 1',
            explicationprixminimal:'Mentionner le montant minimal que peut proposer un acheteur',
            explicationprix:'Mentionner le prix d\'achat direct du produit',
            explicationnumerodirect:'Votre numéro d\'appel direct',
            explicationnumerowhatsapp:'Votre numéro Whatsapp',
            aucunresultat:'Aucun résultat !',
            messagerecherche:'Essayez de choisir d\'autre catégorie ou de reformuler votre recherche.',
            informtionsupplementaire:'Informtion supplementaire',
            photodeprofil:'Photo de profil',
            finalisationencour:'Finalisation en cour...',
            veuillezremplirtousleschamps:'Veuillez remplir tous les champs',
            sexe:'Sexe',
            homme:'Homme',
            femme:'Femme', 
            datedenaissance:'Date de naissance', 
            descriptiondevotreboutique:'Description de votre boutique', 
            retour:'Retour',
            suivant:'Suivant',
            finaliser:'Finaliser',
            erreurdescriptioncourprofil:'Votre description doit avoir plus de 200 caractères',
            erreurdescriptionlongprofil:'Votre description doit avoir moins de 600 caractères',
            paysorigine:'Pays d\'origine',
            vousavezenregistre:'Vous avez enregistré :',
            articles:'articles',
            tout:'Tout',
            envente:'En vente',
            encourdevente:'En cour de vente',
            nonvendus:'Non-vendus',
            vendus:'Vendus',
            gains:'Gains',
            debitersurlesderniersmois:'montant total débiter au cour de l\'année',
            creditersurlesderniersmois:'montant total créditer au cour de l\'année',
            statistiquesdesarticles:'Statistiques des articles',
            gainstotaldesarticlesenventes:'Gains total des articles en ventes',
            mdpdifferentdemdpc:'Le mot de passe et sa confirmation sont différents',
            mdpdinferieurahuit:'Votre mot de passe doit être supérieur ou égal à 8 caractères',
            mdpmajuscule:'Votre mot de passe doit commencer par une lettre majuscule',
            emailexistdeja:'Cet e-mail existe déjà',
            codeverification:'Code de vérification',
            errorcode:'Code incorrect',
            envoyeunnouveaucode:'Cliquez ici, pour envoyer un nouveau code',
            validecodeenvoye:'Un nouveau code a été envoyé',
            messagecode:'Saisissez ici le code envoyé par e-mail...',
            codecorrectlogin:'Code correct, patientez pour l\'étape suivante...',
            codecorrect:'Code correct, patientez vous allez être redirigé...',
            paniervide:'Votre panier est vide',
            recherchepanier:'Recherchez les produits dont vous avez besoin sur MEL',
            recherchepaniersuite:'et cliquez sur Ajouter au panier.',
            ventesencours:'Ventes en cours',
            ventesconclues:'Ventes conclues',
            populairesencemoment:'Populaires en ce moment',
            lesarticlesenventescesdernières24h:'Les articles en ventes ces dernières 24h.',
            voirplusdecategories:'Voir plus de catégories',
            lesmeilleursvendeurs:'Les meilleurs vendeurs',
            consulterleprofil:'Consulter le profil',
            prixdesartices:'Prix des artices',
            priseenchargeduproduit:'Prise en charge du produit',
            messagealertpanier:'Ces articles ne peuvent pas être livrés à domicile. Veuillez choisir un point de relais pour la récupération.',
            pieces:'pièces',
            signaler:'Signaler',
            aproposdecetarticle:'A propos de cet article',
            touslesprixincluentlatva:'Tous les prix incluent la TVA',
            visiterlaboutique:'Visiter la boutique',
            messagealertdetailpage:'Cet article ne peut pas être livré à domicile. Veuillez choisir un point de relais pour la récupération.',
            votrelistedesouhaitsestvide:'Votre liste de souhaits est vide',
            votrelistedabonneeestvide:'Votre liste d\'abonnée est vide.',
            messagelistedesouhait:'Recherchez les produits dont vous avez besoin sur MEL.COM et cliquez sur Ajouter au panier.',
            lesplusdemandes:'Les plus demandés',
            avis:'avis',
            accepteterme:'J\'accepte les termes relatifs à la charte de confidentialité sur MEL.COM.',
            consulterlestermes:'Consulter les termes',
            lemaximundimageautoriseeestde5:'le maximun d\'image autorisée est de 5',
            suivrecetteboutique:'Suivre cette boutique',
            boutiquesuivie:'Boutique suivie',
            suivipar:'Suivi(e) par',
            motdepasseouemailincorrect:'Mot de passe ou Email incorrect',
            mois:'["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"]',
            supprimer:'Supprimer',
            annuler:'Annuler',
            messagedeletepanier:'Voulez-vous vraiment supprimer cet article du panier ?',
            messagedeletearticle:'Voulez-vous vraiment supprimer cet article de votre boutique ?',
            aucunarticletrouve:'Aucun article trouvé',
            recusencourlivraison:'Commandes en cours de livraison',
            recusencourrecuperation:'Commandes en cours de recuperation',
            recusvalides:'Commandes validés',
            recusannules:'Commandes annulés',
            recevoirdesnotificationsdacheteurspotentiels:'Recevoir des notifications d\'acheteurs potentiels',
            selectionnerdesimagesdelarticlepourlepublier:'Selectionner des images de l\'article pour le publier',
            messagearticlenotfound:'Désolé, l\'article que vous recherchez n\'a pu être trouvé car le propriétaire l\'a supprimé.',
            articlenotfound:'Article introuvable',
            enchereendirect:'enchères actuellement en direct',
            live:'DIRECT',
            allezaudirect:'Allez au direct',
            endirect:'En direct',
            bientot:'Bientôt',
            terminee:'Terminée',
            debutele:'Debuté le',
            elementvendu:'Eléments vendus',
            crediteportefeuille:'Dépôt d’argent',
            debiteportefeuille:'Retrait d’argent',
            montanttotal:'Montant total',
            dernieretransaction:'dernière transaction',
            creditermoncompte:'Déposer de l’argent',
            debitermoncompte:'Retirer de l’argent',
            saissisezlemontantenxaf:'Saisissez votre montant en Franc cfa',
            motdepassedevotreboutique:'Mot de passe de votre boutique',
            motdepasseincorrect:'Mot de passe incorrect',
            numero9chiffre:'Votre numéro doit avoir 9 chiffres',
            numeroraongenonautorise:'Numéro Orange non autorisé',
            numeromtnnonautorise:'Numéro MTN non autorisé',
            payer:'Payer',
            cameroun:'Cameroun',
            amount:'Montant',
            saissisezvotrenumeroomoumomo:'Saissisez votre numero OM ou MOMO',
            crediter:'Dépôt',
            debiter:'Retrait',
            soldeinsuffissant:'Votre solde est insuffisant',
            soldeacheteurinsuffissant:'Le solde de l\'acheteur est insuffisant pour terminer la transaction',
            veuillezrechargerwallet:'Votre solde est insuffisant veuillez recharger votre portefeuille',
            numeroincorrect:'Numéro incorrect',
            erreurcontactadmin:'Erreur: veuillez réessayer ou contacter le service client',
            remplirleschamps:'Veuillez remplir les champs',
            aucunetransaction:'Vous n\'avez aucune transaction',
            aucunecommande:'Vous n\'avez rien commandé',
            encourachat:'En cour d\'achat',
            debitsuccess:'Retrait d\'argent effectué avec succès ',
            creditsuccess:'Dépôt d\'argent effectué avec succès',
            newenchere:'Une nouvelle enchère est disponible.',
            textnumerorelai:'Point de relai No: ',
            identifiantdelarticle:'Identifiant de l\'article: ',
            payeravance:'Payer l\'avance de ',
            numerocni:'numéro de votre CNI valide',
            numerotel:'numéro de téléphone',
            etapeasuivre:'Étapes à suivre',
            etape1:'Choisissez un point de relai où récupérer votre article.',
            etape2:'Fournissez votre numéro de CNI valide et un numéro de téléphone disponible.',
            etape3:'Payez les 10% du prix de l\'article et le reste plus les frais de prise en charge (100 Berry) une fois l\'article livré au point de relai par le vendeur.',
            etape4:'Le vendeur aura 6h pour livrer l\'article, et vous 24h pour récupérer cet article au point de relai.',
            etape5:'En cas de non retour du vendeur, les 10% du prix de l\'article prélevés sur votre compte seront remboursés.',
            etape6:'Une fois l\'achat enclenché, il ne pourra plus être annulé, sauf en cas de non livraison ou en cas de non conformité de l\'article.',
            voscommandes:'Vos commandes',
            recherchezmatricule:'Recherchez un matricule',
            produits:'Produits',
            quantites:'Quantités',
            montantverse:'Montant versé',
            montantrestant:'Montant restant',
            status:'Status',
            vendeur:'Vendeur',
            acheteur:'Acheteur',
            enattentedelivraison:'En attente de livraison',
            enattentederecuperation:'En attente de recuperation',
            livre:'Livrée',
            annule:'Annulée',
            datedecreation:'Date de création',
            datelivraison:'delai de livraison',
            encourlivraison:'En cour de livraison',
            encourrecuperation:'En cour de recuperation',
            valide:'Validée',
            vous:'Vous',
            encherissezunmontantsuperieur:'Enchérissez un montant supérieur à l\'enchère précédent',
            montantdejapropose:'Oups une autre boutique a enchèri ce montant avant vous.',
            copierlelien:'Copier le lien',
            messagliencopy:'Lien copié avec succès',
            aencheriunmontantde:'a enchéri un montant de',
            group:'Groupe',
            infosarticle:'Infos article',
            quitterlarencontre:'Quitter',
            salonnumero:'Salon enchère numéro',
            adjugervendu:'Adjugé vendu à la boutique',
            pourlemontantde:'pour le montant de',
            contacteznous:'Contactez-nous',
            ventesencheretermine:'Cette vente aux enchères est terminée, merci pour votre participation.',
            alertAccueil:'Les articles disponibles dans votre fil d\'actualité, sont les articles répertorié dans votre ville de résidence.',
            envoyeznousunmessage:'Envoyez nous un message',
            envoyer:'Envoyer',
            telephone:'Téléphone',
            adresse:'Adresse',
            suiveznoussur:'Suivez nous sur',
            localisation:'Localisation',
            mailsend:'Mail envoyé avec succès',
            faiteunchoix:'Faite un choix',
            impossibledesupprimerarticle:'Cet article ne peut être supprimer',
            a:'à',
            plusde:'Plus de',
            aucunboutiquetrouve:'Aucune boutiques trouvées',
            aucunenotification:'aucune notification !',
            certainsarticleindisponible:'L\'achat de certain(s) articles a échoué (indisponible ou déjà vendu)',
            articleindisponible:'L\'achat de l\'article a échoué (indisponible ou déjà vendu)',
            pasaheure:'Nous avons détecté que vous n\'êtes pas à l\'heure, veuillez configurer votre horloge sur UTC+01:00 et réactualiser la page.',
            emailboutique:'Email de votre boutique',
            emailnotexist:'Cet email n\'est associé à aucune boutique',
            motdepasserenitialise:'Votre mot de passe a été réinitialisé',
            errorstructurepasswordcaractere:'Pour votre securité, votre mot de passe doit contenir au moins un caractère spécial.',
            errorstructurepasswordnumber:'Pour votre securité, votre mot de passe doit contenir au moins un chiffre.',
            errorstructurepasswordlowercase:'Pour votre securité, votre mot de passe doit contenir au moins une lettre minuscule.',
            aucunenchere:'Aucun enchère trouvé',
            verifier:'Vérifier',
            detectionposition:'Nous vous avons géolocalisé à ',
            connexion:'Connexion',
            inscriptioncomponent:'Inscription',
            caissier:'Caissier(ère)',
            recuenvoye:'Les reçus ont été envoyé avec succès',
            recunonenvoye:'Les reçus n\'ont pas pu être envoyé avec succès',
            etape:'Étape',
            recuencourdecreation:'Reçu en cour de création',
            recuencourdenvoie:'Reçu en cour d\'envoie',
            ignorerbutton:'ignorer',
            telechargerbutton:'Télécharger',
            downloadapp:'Installer notre application gratuitement et accédez à la plateforme en un clic !',
            installios:'Pour installer MEL Caisse, appuyez sur le bouton Partager, puis choisissez Sur l’écran d’accueil.',
            installsafari:'Pour installer MEL Caisse sur Safari, ouvrez le menu Fichier puis choisissez Ajouter au Dock.',
            installfirefox:'L’installation automatique n’est pas disponible sur Firefox. Utilisez Chrome, Edge ou Safari mobile pour installer MEL Caisse.',

        },


        en: {
            slogan:'Your <object> is worth more than your <ex> ? Sell it !',
            entrerlaraisondelannulationenfrancais:'Enter the reason for cancellation in French',
            entrerlaraisondelannulationenanglais:'Enter the reason for cancellation in English',

            vousetessurlepointdannulerlacommande: 'You are about to cancel the order',
            erreurlorsduprocessusdevalidationdelacommande: 'Error during order validation process',
            relainotfound:'This account is not linked to a relay point.',
            accessinterdit:'no access',
            total:"Total",
            messagecordiale:"this receipt does not confirm the legality of the product, just the confirmation of the transaction on the platform.",
            numero:"Number",
            facture:'invoice',
            messageerrorrectoverso:"photos of both sides of the ID card are required",
            messageerrorrectoversoacheteur:"Add the front and back of the buyer's ID card",
            messageerrorrectoversovendeur:"Add the front and back of the seller's ID card",
            taillecni:"JPG, PNG, GIF or WEBP image, 5 MB max",
            remplacerimage:"Replace",
            validez:"Confirm",
            annuler:'Cancel',
            recuperationvalidee:"Validated recovery",
            Avezvousrecularticledelacommande:"Did you receive the article from the order",
            rectodelacniduvendeur:"front of the vendor's cni",
            versodelacniduvendeur:"back of the vendor's ID card",
            rectodelacnidelacheteur:"front of the buyer's cni",
            versodelacnidelacheteur:"back of the buyer's cni",
            voulezvousvalisezcommande:"Do you want to confirm the order",
            pointderelais:"Relay point No",
            connecter: 'Log on to',
            messagelogin:'Enter your e-mail address and password.',
            nomutilisateur:'User name',
            motdepasse:'Password',
            motdepasseoublie:'Forgot your password ?',
            btnconnecter: 'Sign in',
            pasencoreconnecte: 'No account yet ?',
            creeruncompte:'Create one here.',
            partagerseque:'Share what',
            vousnutilisezplus:'you no longer use',
            nousle :'we\'ll ',
            revendons:'sell it',
            pourvous:'for you.',
            inscription:'Register at',
            messageinscription:'Enter your details to validate the registration.',
            vousavezdejauncompte: 'Already have an account?',
            connectervousici:'Login here.',
            btninscription: 'Register now',
            confirmemotdepasse:'Confirm password',
            nouveaumotdepasse:'New password',
            email:'Email',
            langue:'Language',
            ventesflash:'Flash sales',
            lesventesseterminentdans:'Sales end in',
            lesventesrecommenceronta:'Sales will resume in',
            affichertouslesarticles:'Show all articles',
            debuterunevente:'Starting a sale',
            bannierepublicitaire:'Advertising banner',
            prix:'Prices',
            datedecreation:'Created date',
            delailivraison:'Delivery time',
            delairecuperation:'Recovery time',
            validele:'Validated on',
            annulele:'Cancelled on',
            categories:'Categories',
            avismoyen:'Average opinion',
            accueil:'Home',
            boutiques:'Shops',
            consulter:'Visit',
            encheres:'Auctions',
            monprofil:'My profile',
            recherchez:'Search...',
            abonnes:'subscribers',
            entrepreneuse:'Entrepreneur',
            entrepreneur:'Entrepreneur',
            niveau:'Level',
            alert:'It is important to update your information regularly.',
            compte:'Account',
            mesabonnees:'My Subscribers',
            mescommandes:'Orders',
            portefeuille:'My wallet',
            debit:'Flows',
            credit:'Credits',
            mesarticles:'My articles',
            messtatistiques:'My statistics',
            description:'Description',
            membredepuis:'Member since',
            produit:'Product',
            ajoutdunnouveauproduit:'Adding a new product',
            cliquezouglissezpourajouterdesimages:'Click or drag to add images.',
            pourrecevoirlespropositionsdeprixactiverlesencheres:'to receive price proposals to activate auctions',
            publiercetarticle:'Publish this article',
            marque:'Brand',
            nom:'Name',
            couleur:'Color',
            taille:'Size',
            ville:'City',
            stockage:'Storage',
            pixelcameraavant:'Pixel Camera front',
            pixelcameraarriere:'Rear Pixel Camera',
            ram:'Ram',
            Empreinte:'Footprint',
            non:'No',
            oui:'Yes',
            cpu:'Cpu(processor)',
            systemedexploitation:'Operating system',
            cartegraphiquededie:'Dedicated graphics card',
            etatsur10:'Condition out of 10',
            tailleenpouce:'Size in inches',
            quantiteenlitre:'Quantity in litre',
            quartier:'Neighbourhood',
            superficie:'Area',
            nombredepiece:'Number of pieces',
            nombredechambre:'Number of rooms',
            nombredesalon:'Number of lounges',
            nombrededouche:'Number of showers',
            nombredecuisine:'Number of kitchens',
            prixminimaldelenchere:'Minimum auction price',
            numerodirect:'Direct number',
            numerowhatsapp:'Whatsapp number',
            quantitedisponible:'Quantity available',
            exemplenike:'Example: Nike',
            exempleairmax:'Example: Air MAX',
            rouge:'Red',
            exemplexlou42:'Example: XL or 42',
            exempledouala:'Example: Douala',
            descriptionaddproduct:'Describe the product in as much detail as possible',
            exemple500go:'Enter the value in Gigabyte',
            exemple8megapixel:'Enter the value in Megapixels',
            exemple16go:'Enter the value in Gigabyte',
            exemple2ghz:'Entrez la valeur en Gigahertz',
            exemplewindows10ouandroid:'Example: Windows 10 or Android',
            exemple2go:'Enter the value in Megabyte',
            exmepleetat:'Enter the value on 10',
            exemplepouces:'Enter the value in inches',
            exemple1litre:'Enter the value in litre',
            exemplevillageentreebille:'Example: Village log entry',
            exemple250metrecarre:'Enter the value in square metres',
            exemple6:'Example: 6',
            exemple2:'Example: 2',
            exemple1:'Example: 1',
            explicationprixminimal:'Mention the minimum amount that a buyer may offer',
            explicationprix:'Mention the direct purchase price of the product',
            explicationnumerodirect:'Your direct dial number',
            explicationnumerowhatsapp:'Your Whatsapp number',
            aucunresultat:'No results!',
            messagerecherche:'Try choosing another category or reformulating your search.',
            informtionsupplementaire:'Additional information',
            photodeprofil:'Profile picture',
            finalisationencour:'Finalisation in progress...',
            veuillezremplirtousleschamps:'Please complete all fields',
            sexe:'Gender',
            homme:'Men',
            femme:'Woman',
            datedenaissance:'Date of birth', 
            descriptiondevotreboutique:'Description of your shop', 
            retour:'Back to',
            suivant:'Next',
            finaliser:'Finalise',
            erreurdescriptioncourprofil:'Your description must be more than 200 characters long',
            erreurdescriptionlongprofil:'Your description must be less than 600 characters long',
            paysorigine:'Country of origin',
            vousavezenregistre:'You have registered :',
            articles:'articles',
            tout:'All',
            envente:'On sale',
            encourdevente:'In the course of sale',
            nonvendus:'Not sold',
            vendus:'Sold',
            gains:'Earnings',
            debitersurlesderniersmois:'total amount debited during the year',
            creditersurlesderniersmois:'total amount credited during the year',
            statistiquesdesarticles:'Article statistics',
            gainstotaldesarticlesenventes:'Total earnings from items on sale',
            mdpdifferentdemdpc:'The password and its confirmation are different',
            mdpdinferieurahuit:'Your password must be at least 8 characters long',
            mdpmajuscule:'Your password must start with a capital letter',
            emailexistdeja:'This e-mail already exists',
            codeverification:'Verification code',
            errorcode:'Invalid code',
            envoyeunnouveaucode:'Click here to send a new code',
            validecodeenvoye:'A new code has been sent',
            messagecode:'Enter the code sent by e-mail here...',
            codecorrectlogin:'Code correct, please wait for the next step...',
            codecorrect:'Code correct, please wait, you will be redirected... ',
            paniervide:'Your basket is empty',
            recherchepanier:'Find the products you need on MEL',
            recherchepaniersuite:'and click on Add to basket.',
            ventesencours:'Sales in progress',
            ventesconclues:'Completed sales',
            populairesencemoment:'Popular at the moment',
            lesarticlesenventescesdernières24h:'Items on sale in the last 24 hours.',
            voirplusdecategories:'See more categories',
            lesmeilleursvendeurs:'Best sellers',
            consulterleprofil:'View profile',
            prixdesartices:'Item prices',
            priseenchargeduproduit:'Product support',
            messagealertpanier:'These items are not available for home delivery. Please select a pick-up location.',
            pieces:'Items',
            signaler:'Report',
            aproposdecetarticle:'About this article',
            touslesprixincluentlatva:'All prices include VAT',
            visiterlaboutique:'Visit the store',
            moncompte:'My account',
            messagealertdetailpage:'This item cannot be home delivery. Please select a pick-up location.',
            votrelistedesouhaitsestvide:'Your wish list is empty',
            votrelistedabonneeestvide:'Your subscriber list is empty.',
            messagelistedesouhait:'Search for the products you need on MEL.COM and click on add to cart.',
            lesplusdemandes:'The most popular',
            avis:'opinion',
            accepteterme:'I accept the terms of the confidentiality charter on MEL.COM',
            consulterlestermes:'Consult the terms',
            lemaximundimageautoriseeestde5:'The maximum number of images allowed is 5',
            suivrecetteboutique:'Follow this shop',
            boutiquesuivie:'Followed shop',
            suivipar:'Followed by',
            motdepasseouemailincorrect:'Incorrect password or email address',
            mois:'["January","February","March","April","May","June","July","August","September","October","November","December"]',
            supprimer:'Delete',
            messagedeletepanier:'Do you really want to remove this item from your basket ?',
            messagedeletearticle:'Do you really want to remove this item from your shop ?',
            aucunarticletrouve:'No items found',
            recusencourlivraison:'Orders being delivered',
            recusencourrecuperation:'Orders being recovered',
            recusvalides:'Validated orders',
            recusannules:'Cancelled orders',
            recevoirdesnotificationsdacheteurspotentiels:'Receive notifications from potential buyers',
            selectionnerdesimagesdelarticlepourlepublier:'Select images from the article for publication',
            messagearticlenotfound:'Sorry, the article you are looking for could not be found because the owner has deleted it.',
            articlenotfound:'Article Not Found',
            enchereendirect:'auctions currently live',
            live:'LIVE',
            allezaudirect:'Go live',
            endirect:'Live',
            bientot:'Coming soon',
            terminee:'Completed',
            debutele:'Started on',
            elementvendu:'Items sold',
            crediteportefeuille:'Money deposit',
            debiteportefeuille:'Money withdrawal',
            montanttotal:'Total amount',
            dernieretransaction:'last transaction',
            creditermoncompte:'Deposit money',
            debitermoncompte:'Withdraw money',
            saissisezlemontantenxaf:'Enter your amount in Franc cfa',
            motdepassedevotreboutique:'Password for your shop',
            motdepasseincorrect:'Incorrect password',
            numero9chiffre:'Your number must have 9 digits',
            numeroraongenonautorise:'Unauthorised Orange number',
            numeromtnnonautorise:'Unauthorised MTN number',
            payer:'Pay',
            cameroun:'Cameroon',
            amount:'Amount',
            saissisezvotrenumeroomoumomo:'Enter your OM or MOMO number',
            crediter:'Deposit',
            debiter:'Withdraw',
            soldeinsuffissant:'Your balance is insufficient',
            soldeacheteurinsuffissant:'The buyer\'s balance is insufficient to complete the transaction',
            veuillezrechargerwallet:'Your balance is insufficient please top up your wallet',
            numeroincorrect:'Incorrect number',
            erreurcontactadmin:'Error: please try again or contact customer service',
            remplirleschamps:'Please fill in the fields',
            aucunetransaction:'You have no transactions',
            encourachat:'In the process of purchase',
            aucunecommande:'You haven\'t ordered anything',
            debitsuccess:'Cash withdrawal successfully completed ',
            creditsuccess:'Successful deposit of money',
            newenchere:'A new auction is available.',
            textnumerorelai:'Relay point No: ',
            payeravance:'Advance payment of ',
            numerocni:'your valid identity card number',
            numerotel:'telephone number',
            etapeasuivre:'Steps to follow',
            etape1:'Choose a pick-up point for your item.',
            etape2:'Provide your valid NIC number and an available telephone number.',
            etape3:'Pay 10% of the price of the item and the rest plus the handling fee (100 Berry) once the item has been delivered to the relay point by the seller..',
            etape4:'The seller will have 6 hours to deliver the item, and you will have 24 hours to collect it from the relay point.',
            etape5:'If the seller does not return the item, the 10% of the price of the item deducted from your account will be refunded.',
            etape6:'Once the purchase has been made, it cannot be cancelled, except in the event of non-delivery or non-compliance of the item.',
            voscommandes:'Your orders',
            recherchezmatricule:'Search for a personnel number',
            produits:'Products',
            quantite:'Quantities',
            montantverse:'Amount paid',
            montantrestant:'Remaining amount',
            status:'Status',
            vendeur:'Seller',
            acheteur:'Buyer',
            enattentedelivraison:'Awaiting delivery',
            enattentederecuperation:'Awaiting recovery',
            livre:'Delivered',
            annule:'Cancelled',
            datelivraison:'Delivery time',
            encourlivraison:'In course of delivery',
            encourrecuperation:'In course of recovery',
            vous:'You',
            encherissezunmontantsuperieur:'Bid a higher amount than the previous bid',
            montantdejapropose:'Oops another shop has bid this amount before you.',
            copierlelien:'Copy link',
            messagliencopy:'Link successfully copied',
            aencheriunmontantde:'bid a sum of',
            group:'Group',
            infosarticle:'Article details',
            quitterlarencontre:'Leave Meet',
            salonnumero:'Salon auction number',
            adjugervendu:'Sold at the boutique',
            pourlemontantde:'for the amount of',
            contacteznous:'Contact us',
            ventesencheretermine:'This auction is over, thank you for your participation.',
            alertAccueil:'The articles available in your news feed are those listed in your home town.',
            envoyeznousunmessage:'Send us a message',
            envoyer:'Send',
            telephone:'Telephone',
            adresse:'Address',
            suiveznoussur:'Follow us on',
            localisation:'Location',
            mailsend:'Mail sent successfully',
            faiteunchoix:'Make a choice',
            identifiantdelarticle:'Article identifier: ',
            impossibledesupprimerarticle:'This article cannot be deleted',
            a:'to',
            plusde:'More than',
            aucunboutiquetrouve:'No shops found',
            aucunenotification:'no notificationpassw !',
            certainsarticleindisponible:'Some items have not been purchased (unavailable or already sold)',
            articleindisponible:'The purchase of the item was unsuccessful (unavailable or already sold)',
            pasaheure:'We have detected that you are not on time. Please set your clock to UTC+01:00 and refresh the page.',
            emailboutique:'Your shop\'s email address',
            emailnotexist:'This email is not associated with any shop',
            motdepasserenitialise:'Your password has been reset',
            errorstructurepasswordcaractere:'For your security, your password must contain at least one special character.',
            errorstructurepasswordnumber:'For your security, your password must contain at least one number.',
            errorstructurepasswordlowercase:'For your security, your password must contain at least one lower-case letter.',
            aucunenchere:'No auction found',
            verifier:'Check',
            detectionposition:'We have geolocated you at ',
            connexion:'Sign in',
            inscriptioncomponent:'Sign up',
            caissier:'Cashier',
            recuenvoye:'Receipts have been sent successfully',
            recunonenvoye:'Receipts could not be sent successfully',
            etape:'Stage',
            recuencourdecreation:'Received in the course of creation',
            recuencourdenvoie:'Received in the post',
            ignorerbutton:'skip',
            telechargerbutton:'Download',
            downloadapp:'Install our free application and access the platform in just one click!',
            installios:'To install MEL Cashier, tap the Share button, then choose Add to Home Screen.',
            installsafari:'To install MEL Cashier on Safari, open the File menu and choose Add to Dock.',
            installfirefox:'Automatic installation is not available on Firefox. Use Chrome, Edge, or mobile Safari to install MEL Cashier.',
        }, 
    },
})


export default i18n
